import { MarkdownImage } from '@squareup/dex-ui-shared-markdown-components';
import React, { FC } from 'react';

interface MdxImageProps {
  src?: string;
  alt?: string;
  width?: string;
  height?: string;
}

const MdxMdxImage: FC<MdxImageProps> = ({
  src = '',
  alt = '',
  width,
  height,
}) => {
  return (
    <MarkdownImage
      src={src}
      alt={alt}
      {...(width !== undefined ? { width } : {})}
      {...(height !== undefined ? { height } : {})}
    />
  );
};

MdxMdxImage.displayName = 'MdxImage';

export { MdxMdxImage };
